/*
 * @Description: 
 * @Author: Rabbiter
 * @Date: 2023-03-26 15:27:05
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './resource/font/iconfont.css'
import '@/resource/global.css'
import ElementUI from 'element-ui';
import request from './utils/request';
import './resource/font2/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css';

// 移动端适配
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.config.productionTip = false

// 同时注册两个 UI 库，通过响应式判断使用哪个
Vue.use(ElementUI);
Vue.use(Vant);

Vue.prototype.request = request;

// 添加全局判断移动端的方法
Vue.prototype.$isMobile = () => {
  return window.innerWidth <= 768;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
